import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AjustesUsuario } from '../../ajustesUsuario.service';
import { Persona } from 'src/app/shared/model/security/persona.model';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import { FormGroup, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-datos-personales',
    standalone: true,
    templateUrl: './datos-personales.component.html',
    imports: [
      ReactiveFormsModule,
      CommonModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule
    ],
})
export class DatosPersonalesComponent implements OnInit {
  formGroupPersona: FormGroup;
	personaObj : Persona=new Persona;
  usuarioObj : Usuario ;
  get formUsuar() { return this.formGroupPersona.controls; }
  constructor(private ajustesService:AjustesUsuario, 
    private formBuilder: FormBuilder,private router: Router, private cdr: ChangeDetectorRef) { }
  ngOnInit() {
    this.formGroupPersona = this.formBuilder.group({
      controlNombre: ['', Validators.required],
      controlAPaterno: ['', Validators.required],
      controlAMaterno: ['', Validators.required],
      controlEmail: ['', [Validators.required, Validators.email]],
      // controlFechaNac: [''],
    });
    this.consultaDatosUsuario();
  }
  consultaDatosUsuario(){
    this.ajustesService.getDatosSesion().subscribe(res=>{
      if(res!=null){
        this.personaObj=res.persona;
        this.usuarioObj=res.usuario;
        this.formGroupPersona.patchValue({
          controlNombre: this.personaObj?.nombre ?? '',
          controlAPaterno: this.personaObj?.apellidoPaterno ?? '',
          controlAMaterno: this.personaObj?.apellidoMaterno ?? '',
          controlEmail: this.personaObj?.correoelectronico ?? '',
        }, { emitEvent: false });
        this.formGroupPersona.markAsPristine();
        this.formGroupPersona.markAsUntouched();
        this.cdr.detectChanges();
      }
    });
  }
  guardaDatosUsuario(){
    this.formGroupPersona.markAllAsTouched();
    this.syncPersonaFromForm();
    this.ajustesService.actulizaDatosPersona(this.personaObj).subscribe(response=>{
        swal.fire({
          title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
          text: response.pMensaje,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Aceptar',
          icon: response.pCodRetorno === '00000' ? 'success' : 'warning'
        }).then(respMsj=>{
          if (response.pCodRetorno === '00000') 
             this.router.navigate(['admin/ajustes']);
        });

    }, error => {
      swal.fire({
        title: 'ERROR',
        text: error?.error?.pMensaje || error?.message || 'No fue posible actualizar los datos personales.',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
        confirmButtonText: 'Aceptar',
        icon: 'error'
      });
    });
  }
  cancelar() {
    this.router.navigate(['admin/ajustes']);
  }

  private syncPersonaFromForm(): void {
    const formValue = this.formGroupPersona.getRawValue();
    this.personaObj.nombre = String(formValue.controlNombre ?? '').trim();
    this.personaObj.apellidoPaterno = String(formValue.controlAPaterno ?? '').trim();
    this.personaObj.apellidoMaterno = String(formValue.controlAMaterno ?? '').trim();
    this.personaObj.correoelectronico = String(formValue.controlEmail ?? '').trim();
  }
}
